<template>
  <div class="page-header">
    <div class="row">
      <div class="col">
        <h3 class="page-title">{{ pageTitle }}</h3>
      </div>
      <div class="col-auto text-right">
        <!-- Default slot for custom actions (buttons, links, etc.) -->
        <slot name="pageHeaderActions"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      required: true
    },
    locale: {
      type: String,
      default: 'en'
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/PageHeader.vue